// SearchBarFilter.tsx
import React, { useEffect, useState } from 'react';
import './SearchBar.css';
interface SearchBarFilterProps {
  onFilter: (value: string) => void;
}

const SearchBarFilter: React.FC<SearchBarFilterProps> = ({ onFilter }) => {
  const [term, setTerm] = useState("");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTerm(e.target.value);
  };

  useEffect(() => {
    onFilter(term);
    if (term.length == 0)
      document.querySelector(".searchBarContainer i")?.classList.add("d-none");
    else
      document.querySelector(".searchBarContainer i")?.classList.remove("d-none");
  }, [term]);

  const clearSearch = () => {
    setTerm("");
  }

  return (
    <div className="searchBarContainer">
      <span className="search-bar-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M10.5005 16.5005C11.2884 16.5005 12.0687 16.3453 12.7966 16.0438C13.5246 15.7423 14.186 15.3003 14.7431 14.7431C15.3003 14.186 15.7423 13.5246 16.0438 12.7966C16.3453 12.0687 16.5005 11.2884 16.5005 10.5005C16.5005 9.71257 16.3453 8.93236 16.0438 8.2044C15.7423 7.47645 15.3003 6.81501 14.7431 6.25786C14.186 5.70071 13.5246 5.25875 12.7966 4.95723C12.0687 4.6557 11.2884 4.5005 10.5005 4.5005C8.9092 4.5005 7.38308 5.13264 6.25786 6.25786C5.13264 7.38308 4.5005 8.9092 4.5005 10.5005C4.5005 12.0918 5.13264 13.6179 6.25786 14.7431C7.38308 15.8684 8.9092 16.5005 10.5005 16.5005ZM16.8205 15.4065L20.4005 18.9865C20.4959 19.0788 20.572 19.1892 20.6244 19.3113C20.6767 19.4333 20.7042 19.5645 20.7052 19.6973C20.7063 19.8301 20.6809 19.9618 20.6305 20.0846C20.5802 20.2075 20.5058 20.3191 20.4119 20.4129C20.3179 20.5067 20.2062 20.5809 20.0833 20.6311C19.9604 20.6813 19.8287 20.7065 19.6959 20.7052C19.5631 20.704 19.4319 20.6763 19.3099 20.6238C19.188 20.5713 19.0777 20.4951 18.9855 20.3995L15.4055 16.8195C13.798 18.0674 11.7753 18.6557 9.74926 18.4647C7.72322 18.2737 5.84611 17.3178 4.50005 15.7916C3.154 14.2653 2.44019 12.2834 2.50393 10.2494C2.56767 8.2154 3.40417 6.28213 4.84315 4.84315C6.28213 3.40417 8.2154 2.56767 10.2494 2.50393C12.2834 2.44019 14.2653 3.154 15.7916 4.50005C17.3178 5.84611 18.2737 7.72322 18.4647 9.74926C18.6557 11.7753 18.0674 13.798 16.8195 15.4055L16.8205 15.4065Z" fill="#697077" />
        </svg>
      </span>
      <input
        className="searchBarInput"
        type="text"
        placeholder="Arama..."
        value={term}
        onChange={handleChange}
      />
      <i className="bi bi-x p-2 d-none" title='Temizle' onClick={clearSearch}></i>
    </div>
  );
};

export default SearchBarFilter;
